import {useFormik} from 'formik'
import {Content} from '../../../../_metronic/layout/components/content'
import {dlrOptions, initRouteConfig, smscTypeOptions} from '../_model'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import {KTCard, KTCardBody, KTIcon} from '../../../../_metronic/helpers'
import useSenderIdsOptions from '../../../hooks/useSenderIdsOptions'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'
import axios from 'axios'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'
import {useRouteConfig} from '../ConfigRoutesProvider'
import {useEffect} from 'react'
import {Link, useParams} from 'react-router-dom'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'
import * as Yup from 'yup'
import FormFieldError from '../../../utils/components/FormFieldError'
import FlatPickrDateTime from '../../../utils/components/FlatPickrDateTime'
import InputFieldTooltip from '../../../utils/components/InputFieldTooltip'

export const routeConfigSchema = Yup.object().shape({
  // smsctype: Yup.number().moreThan(0, 'SMSC Type is required and must be greater than 0'),
  useridparam: Yup.string().required('User ID Param is required'),
  useridvalue: Yup.string().required('Password Value is required'),
  passparam: Yup.string().required('Password Param is required'),
  passvalue: Yup.string().required('Password Value is required'),
  // msisdnparam: Yup.string().required('MSISDN Param is required'),
  // msisdnvalue: Yup.string().required('MSISDN Value is required'),
  // sendervalue: Yup.string().required('Sender Value is required'),
  // senderparam: Yup.string().required('Sender Param is required'),
  // smstextparam: Yup.string().required('SMS Text Param is required'),
  // smstextvalue: Yup.string().required('SMS Text Value is required'),
  url: Yup.string().url('Invalid URL format').required('URL is required'),
  // prefixnotallow: Yup.string().required('Prefix Not Allow is required'),
  name: Yup.string().required('Name is required'),
  // isalternate: Yup.number()
  //   .moreThan(0, 'Required and must be greater than 0')
  //   .required('Required and must be greater than 0'),
  // issetenforce: Yup.number()
  //   .moreThan(0, 'Required and must be greater than 0')
  //   .required('Required and must be greater than 0'),
  // dlrurl: Yup.string().url('Invalid DLR URL format').required('DLR URL is required'),
  // dlravailable: Yup.string().required('DLR Available is required'),
  // routeFaildSmsCount: Yup.number()
  //   .moreThan(0, 'Route Failed SMS Count is required and must be greater than 0')
  //   .required('Route Failed SMS Count is required'),
  // routeAliveTime: Yup.string().required('Route Alive Time is required'),
  // routeSleepTime: Yup.string().required('Route Sleep Time is required'),
  // createdate: Yup.string().required('Create Date is required'),
  // routeTpsLimitSet: Yup.number()
  //   .moreThan(0, 'Route TPS Limit is required and must be greater than 0')
  //   .required('Route TPS Limit is required'),
  // routePerDaySmsSendLimit: Yup.number()
  //   .moreThan(0, 'Route Per Day SMS Send Limit is required and must be greater than 0')
  //   .required('Route Per Day SMS Send Limit is required'),
  // routeIntervelTime: Yup.number()
  //   .moreThan(0, 'Route Interval Time is required and must be greater than 0')
  //   .required('Route Interval Time is required'),
  // routeDefaultSenderId: Yup.number()
  //   .moreThan(0, 'Route Default Sender ID is required and must be greater than 0')
  //   .required('Route Default Sender ID is required'),
  // submittedTimeOut: Yup.number()
  //   .moreThan(0, 'Submitted Timeout is required and must be greater than 0')
  //   .required('Submitted Timeout is required'),
  // retryCounterLimit: Yup.number()
  //   .moreThan(0, 'Retry Counter Limit is required and must be greater than 0')
  //   .required('Retry Counter Limit is required'),
  // retryIntervelTime: Yup.number()
  //   .moreThan(0, 'Retry Interval Time is required and must be greater than 0')
  //   .required('Retry Interval Time is required'),
  smscTypeName: Yup.string().required('SMSC Type Name is required'),
  // sender: Yup.string().required('Sender is required'),
  mnoId: Yup.string().required('Balance Check is required'),
  // balanceUrl: Yup.string().url('Invalid URL format').required('Balance URL is required'),
  // balanceCheck: Yup.number()
  //   .moreThan(0, 'MNO ID is required and must be greater than 0')
  //   .required('MNO ID is required'),
})

const ROUTE_CONFIG_BY_ID = `${BASE_URL}/api/protect/getRoutConfById`
const CREATE_ROUTE_URL = `${BASE_URL}/api/protect/createRoute`
const UPDATE_ROUTE_URL = `${BASE_URL}/api/protect/updateRoute`

const ConfigureRoute = () => {
  const {id} = useParams()
  const {updateRoute, setUpdateRoute} = useRouteConfig()
  const {senderIdsOptions} = useSenderIdsOptions()

  const formik = useFormik({
    initialValues: initRouteConfig,
    validationSchema: routeConfigSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        console.log(values)
        const {
          sender,
          smscTypeName,
          createdate,
          dlravailable,
          routeAliveTime,
          routeSleepTime,
          ...sendValues
        } = values

        const aliveDate = new Date(routeAliveTime)
        const sleepDate = new Date(routeSleepTime)

        // Format as YYYY-MM-DD HH:mm:ss in 24-hour format
        const aliveTime = aliveDate.toISOString().replace('T', ' ').substring(0, 19)
        const sleepTime = sleepDate.toISOString().replace('T', ' ').substring(0, 19)

        if (updateRoute) {
          const updated = {
            id: updateRoute.id,
            dlravailable: values.dlravailable === 'Enable' ? '1' : '0',
            routeAliveTime: aliveTime,
            routeSleepTime: sleepTime,
            ...sendValues,
          }

          const response = await axios.put(UPDATE_ROUTE_URL, updated)

          if (response.status === 200) {
            toast.dismiss()
            toast.success('Updated successfully')
            const result = await response.data

            console.log(result)
            setUpdateRoute(null)
            resetForm()
          }
        } else {
          const response = await axios.post(CREATE_ROUTE_URL, {
            ...sendValues,
            dlravailable: values.dlravailable === 'Enable' ? '1' : '0',
            routeAliveTime: aliveTime,
            routeSleepTime: sleepTime,
          })

          if (response.status === 200) {
            toast.dismiss()
            toast.success('Created successfully')
            const result = await response.data

            console.log(result)
            resetForm()
          }
        }
      } catch (error) {
        toast.dismiss()
        const message = handleAxiosError(error)
        toast.error(message)
        console.log(error)
      }
    },
  })

  const onSelectSmscType = (id: number) => formik.setFieldValue('smsctype', id)

  const resetForm = () => {
    formik.resetForm()
  }

  const onSelectSender = (id: number) => formik.setFieldValue('routeDefaultSenderId', id)

  const setSmscType = (id: number) => {
    let value = ''
    const selected = smscTypeOptions.find((type) => type.id === id)

    if (selected) {
      value = selected.value
    }

    return value
  }

  const setSender = (id: number) => {
    let value = ''
    const selected = senderIdsOptions.find((type) => type.id === id)
    console.log(id)
    console.log(senderIdsOptions)
    console.log(selected)

    if (selected) {
      value = selected.value
    }

    return value
  }

  useEffect(() => {
    resetForm()
    if (updateRoute) {
      formik.setValues({
        ...formik.values,
        smsctype: 0,
        useridparam: updateRoute.useridparam,
        useridvalue: updateRoute.useridvalue,
        passparam: updateRoute.passparam,
        passvalue: updateRoute.passvalue,
        msisdnparam: updateRoute.msisdnparam,
        senderparam: updateRoute.senderparam,
        smstextparam: updateRoute.smstextparam,
        url: updateRoute.url,
        prefixnotallow: updateRoute.prefixnotallow,
        name: updateRoute.name,
        isalternate: updateRoute.isalternate,
        issetenforce: updateRoute.issetenforce,
        dlrurl: updateRoute.dlrurl,
        dlravailable: updateRoute.dlravailable === '1' ? 'Enable' : 'Disable',
        routeFaildSmsCount: updateRoute.routeFaildSmsCount,
        routeAliveTime: updateRoute.routeAliveTime,
        routeSleepTime: updateRoute.routeSleepTime,
        createdate: '',
        routeTpsLimitSet: updateRoute.routeTpsLimitSet,
        routePerDaySmsSendLimit: updateRoute.routePerDaySmsSendLimit,
        routeIntervelTime: updateRoute.routeIntervelTime,
        routeDefaultSenderId: updateRoute.routeDefaultSenderId,
        submittedTimeOut: updateRoute.submittedTimeOut,
        retryCounterLimit: updateRoute.retryCounterLimit,
        retryIntervelTime: updateRoute.retryIntervelTime,
        smscTypeName: setSmscType(updateRoute.smsctype),
        sender: setSender(updateRoute.routeDefaultSenderId),
        balanceCheck: updateRoute.balanceCheck,
        balanceUrl: updateRoute.balanceUrl,
        mnoId: updateRoute.mnoId,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRoute, senderIdsOptions])

  useEffect(() => {
    const getRoute = async () => {
      try {
        toast.loading('Processing..')
        const response = await axios.get(`${ROUTE_CONFIG_BY_ID}/${id}`)
        if (response.status === 200) {
          toast.dismiss()
          const data = await response.data
          setUpdateRoute(data)
        }
      } catch (error) {
        toast.dismiss()
        console.log(error)
        const message = handleAxiosError(error)
        toast.error(message)
      }
    }

    if (id) {
      getRoute()
    }
  }, [id])

  return (
    <Content>
      <h3 className='fs-2x mb-6'>Route Configuration</h3>

      <KTCard>
        <KTCardBody>
          <form onSubmit={formik.handleSubmit} className=''>
            <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3'>
              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>SMSC Type</label>
                  {/* <InputFieldTooltip id='smsctype' content='Add SMS C type' /> */}

                  <ReactSelectBox
                    formik={formik}
                    fieldValue='smscTypeName'
                    placeholder='Select type'
                    setSelect={onSelectSmscType}
                    options={smscTypeOptions}
                  />

                  <FormFieldError name='smscTypeName' formik={formik} />
                </div>
              </div>

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>User ID</label>

                  {/* <InputFieldTooltip
                    id='userid'
                    content='Write user id which you want to assign this Write user id which you want to assign this Write user id which you want to assign this Write user id which you want to assign this'
                  /> */}

                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('useridparam')}
                    type='text'
                    name='useridparam'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='useridparam' formik={formik} />
                </div>
              </div>

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Password</label>

                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('useridvalue')}
                    type='text'
                    name='useridvalue'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='useridvalue' formik={formik} />
                </div>
              </div>

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Billing ID</label>

                  <input
                    placeholder='Enter Pass Param'
                    {...formik.getFieldProps('passparam')}
                    type='text'
                    name='passparam'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='passparam' formik={formik} />
                </div>
              </div>

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>API Key</label>
                  <input
                    placeholder='Enter Pass Value'
                    {...formik.getFieldProps('passvalue')}
                    type='text'
                    name='passvalue'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='passvalue' formik={formik} />
                </div>
              </div>

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>MSISDN Param</label>
                  <input
                    placeholder='Enter MSISDN Param'
                    {...formik.getFieldProps('msisdnparam')}
                    type='text'
                    name='msisdnparam'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='msisdnparam' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>MSISDN Value</label>
                  <input
                    placeholder='Enter MSISDN Value'
                    {...formik.getFieldProps('msisdnvalue')}
                    type='text'
                    name='msisdnvalue'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='msisdnvalue' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Sender Param</label>
                  <input
                    placeholder='Enter Sender Value'
                    {...formik.getFieldProps('senderparam')}
                    type='text'
                    name='senderparam'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='senderparam' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Sender Value</label>
                  <input
                    placeholder='Enter Sender Param'
                    {...formik.getFieldProps('sendervalue')}
                    type='text'
                    name='sendervalue'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='sendervalue' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>SMS Text Value</label>
                  <input
                    placeholder='Enter SMS Text Param'
                    {...formik.getFieldProps('smstextvalue')}
                    type='text'
                    name='smstextvalue'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='smstextvalue' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>SMS Text Param</label>
                  <input
                    placeholder='Enter SMS Text Param'
                    {...formik.getFieldProps('smstextparam')}
                    type='text'
                    name='smstextparam'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='smstextparam' formik={formik} />
                </div>
              </div> */}

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>URL</label>
                  <input
                    placeholder='Enter URL'
                    {...formik.getFieldProps('url')}
                    type='text'
                    name='url'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='url' formik={formik} />
                </div>
              </div>

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Prefix Not Allowed</label>
                  <input
                    placeholder='Enter Prefix Not Allowed'
                    {...formik.getFieldProps('prefixnotallow')}
                    type='text'
                    name='prefixnotallow'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='prefixnotallow' formik={formik} />
                </div>
              </div> */}

              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Name</label>
                  <input
                    placeholder='Enter Name'
                    {...formik.getFieldProps('name')}
                    type='text'
                    name='name'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='name' formik={formik} />
                </div>
              </div>

              {/* <div className='col align-self-center'>
                <div className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input me-3'
                    style={{border: '1px solid #6d6d80'}}
                    name='isalternate'
                    type='checkbox'
                    value='isalternate'
                    id='isalternate'
                    checked={formik.values.isalternate === 1}
                    onChange={() =>
                      formik.setFieldValue('isalternate', formik.values.isalternate === 1 ? 0 : 1)
                    }
                  />
                  <label
                    className='form-check-label text-gray-900 fs-5'
                    htmlFor='isalternate'
                    style={{cursor: 'pointer'}}
                  >
                    Alternate
                  </label>
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Alternate</label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('isalternate')}
                    type='text'
                    name='isalternate'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='isalternate' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col align-self-center'>
                <div className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input me-3'
                    style={{border: '1px solid #6d6d80'}}
                    name='issetenforce'
                    type='checkbox'
                    value='issetenforce'
                    id='issetenforce'
                    checked={formik.values.issetenforce === 1}
                    onChange={() =>
                      formik.setFieldValue('issetenforce', formik.values.issetenforce === 1 ? 0 : 1)
                    }
                  />
                  <label
                    className='form-check-label text-gray-900 fs-5'
                    htmlFor='issetenforce'
                    style={{cursor: 'pointer'}}
                  >
                    Set Enforce
                  </label>
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Set Enforce</label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('issetenforce')}
                    type='number'
                    name='issetenforce'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='issetenforce' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>DLR url</label>

                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('dlrurl')}
                    type='text'
                    name='dlrurl'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='dlrurl' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>DLR Available</label>

                  <ReactSelectBox
                    formik={formik}
                    fieldValue='dlravailable'
                    placeholder='Select type'
                    options={dlrOptions}
                  />

                  <FormFieldError name='dlravailable' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Route Failed Sms Count</label>
                  <input
                    placeholder='Enter count'
                    {...formik.getFieldProps('routeFaildSmsCount')}
                    type='number'
                    name='routeFaildSmsCount'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='routeFaildSmsCount' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Balance Check</label>
                  <input
                    placeholder='Enter balance'
                    {...formik.getFieldProps('balanceCheck')}
                    type='number'
                    name='balanceCheck'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='balanceCheck' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Balance URL</label>
                  <input
                    placeholder='Enter balance URL'
                    {...formik.getFieldProps('balanceUrl')}
                    type='string'
                    name='balanceUrl'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='balanceUrl' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>MNO ID</label>
                  <input
                    placeholder='Enter MNO ID'
                    {...formik.getFieldProps('mnoId')}
                    type='string'
                    name='mnoId'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='mnoId' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Route Alive Time</label>

                  <div id='routeAliveTime'>
                    <FlatPickrDateTime
                      formik={formik}
                      fieldName='routeAliveTime'
                      container='routeAliveTime'
                    />
                  </div>

                  <FormFieldError name='routeAliveTime' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Route Sleep Time</label>

                  <div id='routeSleepTime'>
                    <FlatPickrDateTime
                      formik={formik}
                      fieldName='routeSleepTime'
                      container='routeSleepTime'
                    />
                  </div>

                  <FormFieldError name='routeSleepTime' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Create Date</label>

                  <div id='createdate'>
                    <FlatPickrDateTime
                      formik={formik}
                      fieldName='createdate'
                      container='createdate'
                    />
                  </div>
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Route TPS Limit Set</label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('routeTpsLimitSet')}
                    type='number'
                    name='routeTpsLimitSet'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='routeTpsLimitSet' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>
                    Route Per Day Sms Send Limit
                  </label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('routePerDaySmsSendLimit')}
                    type='number'
                    name='routePerDaySmsSendLimit'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='routePerDaySmsSendLimit' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>
                    Route Intervel Time me (milisecond)
                  </label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('routeIntervelTime')}
                    type='number'
                    name='routeIntervelTime'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='routeIntervelTime' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Default Sender</label>

                  <OptimizedSelectBox
                    formik={formik}
                    fieldValue='sender'
                    placeholder='Select sender'
                    setSelect={onSelectSender}
                    options={senderIdsOptions}
                  />

                  <FormFieldError name='sender' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>
                    Submitted Time Out (milisecond)
                  </label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('submittedTimeOut')}
                    type='number'
                    name='submittedTimeOut'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='submittedTimeOut' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>Retry Counter Limit</label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('retryCounterLimit')}
                    type='number'
                    name='retryCounterLimit'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='retryCounterLimit' formik={formik} />
                </div>
              </div> */}

              {/* <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='fw-semibold fs-6 mb-2 required'>
                    Retry Intervel Time (milisecond)
                  </label>
                  <input
                    placeholder='Enter value'
                    {...formik.getFieldProps('retryIntervelTime')}
                    type='number'
                    name='retryIntervelTime'
                    className='form-control form-control custom-input mb-3 mb-lg-0'
                    autoComplete='off'
                  />

                  <FormFieldError name='retryIntervelTime' formik={formik} />
                </div>
              </div> */}
              {/*  */}
            </div>

            <div className='text-center mt-10'>
              <Link to='/routes/configure-list' type='reset' className='btn btn-light me-3'>
                Cancel
              </Link>
              <button type='submit' className='btn btn-primary' data-kt-users-modal-action='submit'>
                <span className='indicator-label'>
                  {updateRoute ? 'Update Route' : 'Create Route'}
                </span>
              </button>
            </div>
          </form>
        </KTCardBody>
      </KTCard>
    </Content>
  )
}

export default ConfigureRoute
